// upload file
import React from "react";
import { useState, useEffect } from "react";

function UploadImage({ getImageFile }) {
    const [file, setFile] = useState();

    function onFileChange(e) {
        setFile(e.target.files[0]);
        getImageFile(e.target.files[0]);
    }

    useEffect(() => {
        if (!file) return;
        const newFileUrl = URL.createObjectURL(file);
    }, [file]);

    return (
        <div class="file-upload">
            <input
            id="post-input"
            type="file"
            accept=".pdf, .doc, .docx, .jpg, .png, .jpeg"
            onChange={onFileChange}
            ></input>
        </div>
    );
}
export default UploadImage;